'use strict';

exports.__esModule = true;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Icon = require('../../../icon/Icon');

var _Icon2 = _interopRequireDefault(_Icon);

var _IconsStore = require('../../IconsStore');

var _IconsStore2 = _interopRequireDefault(_IconsStore);

var _ImageUploader = require('./ImageUploader.style');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; } /* eslint-disable react/forbid-prop-types */
/* eslint-disable func-names */
/* eslint-disable jsx-a11y/click-events-have-key-events */


var ImageUploader = function ImageUploader(_ref) {
  var props = _objectWithoutProperties(_ref, []);

  var fieldLabel = props.fieldLabel,
      componentName = props.componentName,
      fieldValue = props.fieldValue,
      extendDropDownStyle = props.extendDropDownStyle,
      extendFieldText = props.extendFieldText,
      extendFieldContainer = props.extendFieldContainer,
      icon = props.icon,
      iconSize = props.iconSize,
      isDisabled = props.isDisabled,
      localization = props.localization,
      isEditable = props.isEditable,
      onChange = props.onChange,
      language = props.language,
      submittedLocalization = props.submittedLocalization,
      onFileView = props.onFileView,
      onInputFieldClick = props.onInputFieldClick;

  var _useState = (0, _react.useState)(fieldValue),
      value = _useState[0],
      setValue = _useState[1];

  var _useState2 = (0, _react.useState)(true),
      isFocued = _useState2[0],
      setFocus = _useState2[1];

  var _useState3 = (0, _react.useState)(),
      image = _useState3[0],
      setImage = _useState3[1];

  var _useState4 = (0, _react.useState)(),
      preview = _useState4[0],
      setPreview = _useState4[1];

  var _useState5 = (0, _react.useState)(false),
      isFileViewOverlay = _useState5[0],
      toggleIsFileViewOverlay = _useState5[1];

  var fileInputRef = (0, _react.useRef)(null);

  var getImageFormUrl = function getImageFormUrl(url) {
    return new Promise(function (resolve, reject) {
      var img = new Image();
      img.setAttribute('crossOrigin', 'anonymous');
      img.crossOrigin = 'Anonymous';
      img.onload = function () {
        var canvas = document.createElement('canvas');
        canvas.width = this.width;
        canvas.height = this.height;
        var ctx = canvas.getContext('2d');
        ctx.drawImage(this, 0, 0);
        var dataURI = canvas.toDataURL('image/jpg');
        resolve(dataURI);
      };
      img.onerror = reject;
      img.src = url;
    });
  };

  var displayCardImage = function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regenerator2.default.mark(function _callee(url) {
      var ConvertedBase64, fileObj;
      return _regenerator2.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return getImageFormUrl(url);

            case 2:
              ConvertedBase64 = _context.sent;

              // eslint-disable-next-line no-unused-vars
              fileObj = {
                fileData: 'currentFile',
                fileName: 'name',
                fileType: 'image/png',
                base64: ConvertedBase64,
                compressedVersion: false,
                dimensions: {},
                isConverted: true,
                shouldBeProcessed: true,
                shouldBypassCompression: true
              };

              setPreview(ConvertedBase64);

            case 5:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, undefined);
    }));

    return function displayCardImage(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  (0, _react.useEffect)(function () {
    if (value) {
      displayCardImage(value);
    }
  }, [value]);

  (0, _react.useEffect)(function () {
    if (fieldValue) setValue(fieldValue);else setValue('');
  }, [fieldValue]);

  (0, _react.useEffect)(function () {
    if (image) {
      onChange(image);
      var reader = new FileReader();
      reader.onloadend = function () {
        setPreview(reader.result);
      };
      reader.readAsDataURL(image);
    } else {
      setPreview(null);
    }
  }, [image]);

  var onImageChange = function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regenerator2.default.mark(function _callee2(event) {
      var file;
      return _regenerator2.default.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              file = event.target.files[0];

              if (file && file.type.substr(0, 5) === 'image') {
                setImage(file);
              }

            case 2:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, undefined);
    }));

    return function onImageChange(_x2) {
      return _ref3.apply(this, arguments);
    };
  }();

  var getFocusOnInputField = function getFocusOnInputField() {
    setFocus(true);
    if (document.getElementById('input-container-' + componentName)) {
      document.getElementById('input-container-' + componentName).focus();
    }
  };

  var onButtonClick = function onButtonClick() {
    // `current` points to the mounted text input element
    document.getElementById('input-container-' + componentName).click();
    onInputFieldClick();
  };

  return _react2.default.createElement(
    'div',
    { style: { position: 'relative' } },
    _react2.default.createElement(_ImageUploader.DisableOverLay, { extendDropDownStyle: extendDropDownStyle, isDisabled: isDisabled }),
    _react2.default.createElement(
      _ImageUploader.FieldContainer,
      {
        extendDropDownStyle: extendFieldContainer,
        extendFieldContainer: extendFieldContainer,
        className: 'input-' + componentName,
        onClick: function onClick() {
          return getFocusOnInputField();
        }
      },
      _react2.default.createElement(
        _ImageUploader.FileViewOverlay,
        {
          onClick: function onClick() {
            return toggleIsFileViewOverlay(!isFileViewOverlay);
          },
          isFileViewOverlay: isFileViewOverlay
        },
        _react2.default.createElement(
          'span',
          {
            onClick: function onClick(e) {
              if (e) e.stopPropagation();
            }
          },
          _react2.default.createElement(_ImageUploader.CancelIcon, { onClick: function onClick() {
              return toggleIsFileViewOverlay(false);
            } }),
          _react2.default.createElement(_ImageUploader.FileViewItem, { src: preview })
        )
      ),
      _react2.default.createElement(
        'div',
        { style: { width: '100%' } },
        isFocued && _react2.default.createElement(
          _ImageUploader.ValueTagContainerImage,
          { preview: preview },
          preview ? _react2.default.createElement(
            _react2.default.Fragment,
            null,
            _react2.default.createElement(_ImageUploader.ImagePreview, {
              alt: 'imgpreview',
              src: preview,
              onClick: function onClick() {
                toggleIsFileViewOverlay(!isFileViewOverlay);
                onFileView();
              }
            }),
            _react2.default.createElement(
              _ImageUploader.Text,
              null,
              ' ',
              submittedLocalization,
              ' '
            ),
            isEditable && _react2.default.createElement(
              _ImageUploader.ButtonEdit,
              { onClick: onButtonClick, language: language },
              _react2.default.createElement(_Icon2.default, {
                className: 'icon',
                icon: _IconsStore2.default.getIcon('horizDots'),
                width: 30,
                style: { verticalAlign: '-webkit-baseline-middle' }
              })
            )
          ) : _react2.default.createElement(
            _ImageUploader.AttatchContainer,
            { onClick: onButtonClick },
            icon && _react2.default.createElement(_Icon2.default, {
              className: 'icon',
              icon: _IconsStore2.default.getIcon(icon),
              width: iconSize,
              style: { margin: '0 5px' }
            }),
            localization.attatch,
            ' ',
            fieldLabel
          ),
          isFocued && _react2.default.createElement(_ImageUploader.SearchInput, {
            extendFieldText: extendFieldText,
            style: { display: 'none' },
            ref: fileInputRef,
            id: 'input-container-' + componentName,
            type: 'file',
            accept: 'image/*'
            // value={value}
            , onChange: function onChange(event) {
              return onImageChange(event);
            }
          })
        )
      )
    )
  );
};

ImageUploader.propTypes = process.env.NODE_ENV !== "production" ? {
  fieldValue: _propTypes2.default.string,
  fieldLabel: _propTypes2.default.string.isRequired,
  componentName: _propTypes2.default.string,
  fieldTag: _propTypes2.default.string,
  icon: _propTypes2.default.string,
  onChange: _propTypes2.default.func.isRequired,
  iconSize: _propTypes2.default.number,
  extendDropDownStyle: _propTypes2.default.string,
  extendFieldContainer: _propTypes2.default.array,
  extendFieldText: _propTypes2.default.array,
  validation: _propTypes2.default.array,
  isDisabled: _propTypes2.default.bool,
  isRequired: _propTypes2.default.bool,
  localization: _propTypes2.default.object,
  isEditable: _propTypes2.default.bool,
  language: _propTypes2.default.string,
  submittedLocalization: _propTypes2.default.string,
  onFileView: _propTypes2.default.func,
  onInputFieldClick: _propTypes2.default.func
} : {};

ImageUploader.defaultProps = {
  onFileView: function onFileView() {},
  onInputFieldClick: function onInputFieldClick() {}
};
exports.default = ImageUploader;
module.exports = exports['default'];